<script lang="ts">
  import { t } from '$core/i18n';
</script>

<a class="skip-link" href="#main-content">
  {t('shell.skipToContent')}
</a>

<style>
  .skip-link {
    position: fixed;
    top: var(--space-2);
    left: var(--space-2);
    z-index: var(--z-skip-link);
    padding: var(--space-3) var(--space-4);
    font-family: var(--font-sans);
    font-size: var(--text-body);
    font-weight: var(--weight-medium);
    color: var(--color-accent-fg);
    background: var(--color-accent);
    border-radius: var(--radius-md);
    text-decoration: none;
    transform: translateY(-200%);
    transition: transform var(--dur-fast) var(--ease-out);
  }

  .skip-link:focus-visible {
    transform: translateY(0);
    outline: var(--focus-ring-width) solid var(--color-focus-ring);
    outline-offset: 2px;
  }
</style>